import '../Fusion/Component/Template/Checkout/Checkout'
import '../../../../../Packages/Tms/Tms.Wishlist/Resources/Private/JavaScript/Wishlist'

document.addEventListener('wishlistChanged', function () {
    $('#wishlist-modal').modal('show');
}, false);

// Track added wihlist items with Plausible
document.querySelectorAll('[data-wishlist-action="add"]').forEach(item => {
    item.addEventListener('click', event => {
        var identifier = event.target.getAttribute('data-wishlist-item-identifier');
        var label = event.target.getAttribute('data-wishlist-item-label');

        // Ignore item if the identifier or label is empty
        if (!identifier || !label) return;

        if (window.plausible)
            plausible('Wishlist Item Added', {props: {label: label}});
    }, false);
});

// Highlight complete bookmarked product short items
highlightActiveWishlistItems();
document.addEventListener('wishlistChanged', function () {
    highlightActiveWishlistItems()
}, false);
function highlightActiveWishlistItems() {
    document.querySelectorAll('[data-wishlist-action="toggle"]').forEach(item => {
        var addedToWishlist = item.querySelector('[data-wishlist-action="add"][class~="d-none"]');
        var wishlistItemShort = item.closest('.wishlist-item-short');

        if (wishlistItemShort) {
            if (addedToWishlist)
                wishlistItemShort.classList.add('wishlist-item-short-highlighted', 'border-dark');
            else
                wishlistItemShort.classList.remove('wishlist-item-short-highlighted', 'border-dark');
        }
    });
}

// Highlight/Focus current wishlist item
document.querySelectorAll('[data-wishlist-action="add"],[data-wishlist-action="remove"]').forEach(item => {
    item.addEventListener('click', event => {
        var identifier = event.target.getAttribute('data-wishlist-item-identifier');
        if (!identifier)
            identifier = event.target.previousSibling.getAttribute('data-wishlist-item-identifier');
        if (!identifier)
            return;

        document.querySelectorAll('[data-wishlist-item-thumbnail]').forEach(item => {
            if (item.getAttribute('data-wishlist-item-thumbnail') === identifier)
                item.classList.add('border', 'border-dark');
            else
                item.classList.remove('border', 'border-dark');
        });
    }, false);
});
